import React, { useEffect, useState } from "react";

import { decode } from "html-entities";
import AOS from "aos";
import "aos/dist/aos.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  EmailValidation,
  NonEmptyValidation,
  PhoneNumberValidation,
  StringValidation,
} from "../../Store/validate";
import {
 
  GetSpecificProperty,
  GetUser,
  
  UserServiceRequest,
  UseraboutContent,
} from "../../Api/Api";
import CustomModal from "../CustomModal";
import ServicesAllpages from "../ServicesAllpages";

export default function BSPlotSpecific() {
  useEffect(() => {
    AOS.init();
  }, []);

  const [selectedTab, setSelectedTab] = React.useState("Whats Included");
  const AllTabs = [
    "Whats Included",
    "Whats Not Included",
    "You May Also Want To Know",
  ];

  const state = useSelector((state) => state);

  const [bsPlotSpecif, setBsPlotCont] = useState({});
  const [loginMsg, setLoginMsg] = useState(false);

  const [bsPlotContValidation, setServiceReqValidation] = useState({});

  const setBsPlotContValue = (key, value) => {
    setBsPlotCont({ ...bsPlotSpecif, [key]: value });
    if (bsPlotContValidation[key]) delete bsPlotContValidation[key];
  };

  const setBsPlotContValidationValue = (key, value) => {
    setServiceReqValidation({ ...bsPlotContValidation, [key]: value });
  };

  //error
  const showToastErrorMsg = (errMsg) => {
    toast.error(errMsg, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
      autoClose: 5000,
    });
  };

  //success
  const showToastSuccessMsg = (successMsg) => {
    toast.success(successMsg, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
      autoClose: 3000,
    });
  };

  const [userProfile, setUserProfile] = useState([]);
  useEffect(() => {
    if (state?.auth?.isLoggedIn === true) {
      getBsPlotContProfile();
    }
    getPropertytypefilterList();
  }, []);
  const getBsPlotContProfile = async () => {
    const id = state?.auth?.auth?._id;
    const token = state.auth.auth.token;
    const response = await GetUser(token, id);
    if (response.statusCode === 200) {
      setUserProfile(response.data);
    } else {
      //console.log("error while getting user profile info");
    }
  };

  const naviGation = useNavigate();

  //User Registration api call

  const handleSubmit = async (e) => {
    e.preventDefault();
    let local = localStorage?.getItem("category")?.split("&");
    let local1 = local[0]?.split("/");

    let validate = {};
    validate.name = StringValidation(bsPlotSpecif?.name);
    validate.emailId = EmailValidation(bsPlotSpecif?.emailId);
    validate.subject = NonEmptyValidation(bsPlotSpecif?.subject);
    validate.question = NonEmptyValidation(bsPlotSpecif?.question);
    validate.mobileNumber = PhoneNumberValidation(bsPlotSpecif?.mobileNumber);
    validate.servicesType = NonEmptyValidation(bsPlotSpecif?.servicesType);

    setServiceReqValidation(validate);
    if (Object.values(validate).every((v) => v.status === true)) {
      const Payload = {
        name: bsPlotSpecif.name,
        emailId: bsPlotSpecif.emailId,
        subject: bsPlotSpecif.subject,
        question: bsPlotSpecif.question,
        mobileNumber: bsPlotSpecif.mobileNumber,
        userId: state?.auth?.auth?._id,
        servicesType: bsPlotSpecif.servicesType,
      };

      const response = await UseraboutContent(Payload);
      if (response && response.statusCode === 200) {
       
        showToastSuccessMsg(response.message);
        window.location.reload();
        
        setBsPlotCont({});
      } else {
        showToastErrorMsg(
          response.message || response.error.response.data.message
        );
      }
    } else {
      //console.log("Error while submit a service request");
    }
  };
  // };

  const handleSubmitBsPlotCont = async (e) => {
    e.preventDefault();
    let local = localStorage?.getItem("category")?.split("&");
    let local1 = local[0]?.split("/");
    if (state?.auth?.isLoggedIn) {
      const Payload = {
        name: userProfile.name,
        email: userProfile.email,
        subject: " ",
        question: " ",
        mobileNumber: userProfile.phoneNumber,
        userId: state?.auth?.auth?._id,
        property_id: id,
        type: "property",

      };
      const token = state?.auth?.auth?.token;
      const response = await UserServiceRequest(Payload);
      if (response && response.statusCode === 200) {
        setBsPlotCont({});
        showToastSuccessMsg(response.message);
      } else {
        showToastErrorMsg(
          response.message || response.error.response.data.message
        );
      }
    }
  };

  const [bsPlotContList, setBsPlotContList] = useState({});
  const [metatag, setMetatag] = useState([]);

  const { id } = useParams();
  const getPropertytypefilterList = async () => {
    const response = await GetSpecificProperty(id);
    if (response && response.statusCode === 200) {
      setBsPlotContList(response.data);
    } else {
      setBsPlotContList({});
      showToastErrorMsg(response.message);
    }
  };

  const [bsPlotCont1, setBsPlotCont1] = useState({});
  const [form, setForm] = useState(false);

  const [bsPlotContValidation1, setBsPlotContReqValidation1] = useState({});

  const setServiceReqValue1 = (key, value) => {
    setBsPlotCont1({ ...bsPlotCont1, [key]: value });
    if (bsPlotContValidation1[key]) delete bsPlotContValidation1[key];
  };

  const setServiceReqValidationValue1 = (key, value) => {
    setBsPlotContReqValidation1({ ...bsPlotContValidation1, [key]: value });
  };

  let cat = localStorage?.getItem("category")?.split("?");

  const handleSubmitServiceform = async (e) => {
    e.preventDefault();
    const Payload = {
      name: bsPlotCont1.name,
      email: bsPlotCont1.email,
      subject: bsPlotCont1.subject,
      question: bsPlotCont1.question,
      mobileNumber: bsPlotCont1.mobileNumber,
      type: "property",
      property_id: id,
    };
    // const token = state?.auth?.auth?.token
    //console.log(Payload);
    const response = await UserServiceRequest(Payload);
    if (response && response.statusCode === 200) {
      showToastSuccessMsg(response.message);
      setBsPlotCont1({});
      setForm(false);
    } else {
      showToastErrorMsg(
        response.message || response.error.response.data.message
      );
    }
  };
  return (
    <div className="overflow-pages">
      <ToastContainer />
      <div className="about-banner2 py-5">
        <div className="container">
          <section className="property">
            <div className="container">
              <div className="projectrow">
                <div className="row">
                  <div className="col-lg-11 mx-auto ms-auto">
                    <div className="row">
                      <section className="property1">
                        <div className="container">
                          <div className="row">
                            <div className="col-6">
                              <h2 className="color-maroon fw-bold">
                                {bsPlotContList?.property_name}
                              </h2>
                              <p>
                                <span className="material-symbols-rounded filled-icon close-icon">
                                  location_on
                                </span>
                                {bsPlotContList?.property_information?.address}
                              </p>
                            </div>
                            <div className="col-6 text-end">
                              <div className="row">
                                <div className="col-6">
                                  <h2 className="color-maroon fw-bold">
                                    ₹&nbsp;
                                    {bsPlotContList?.property_information?.price
                                      ? bsPlotContList?.property_information
                                          ?.price
                                      : "N/A"}
                                  </h2>
                                </div>
                                <div className="col-6">
                                  {!state?.auth?.isLoggedIn ? (
                                    <button
                                      type="button"
                                      className="btn mx-2  login-btn"
                                      onClick={() => {
                                        setForm(true);
                                      }}
                                    >
                                      Show Interest
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="btn mx-2  login-btn"
                                      onClick={(e) => {
                                        handleSubmitBsPlotCont(e);
                                      }}
                                    >
                                      Show Interest
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-11 mx-auto ms-auto">
                              <div className="row">
                                <div className="col-lg-6">
                                  <img
                                    className="w-100 m-auto"
                                    style={{ borderRadius: "8px" }}
                                    src={bsPlotContList?.cover_image}
                                    alt=""
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <div className="row">
                                    {bsPlotContList &&
                                      bsPlotContList?.property_image?.map(
                                        (image, index) => {
                                          return (
                                            <div
                                              className="col-lg-6"
                                              key={index}
                                            >
                                              <img
                                                style={{
                                                  width: "250px",
                                                  height: "250px",
                                                  borderRadius: "8px",
                                                }}
                                                src={image}
                                                alt=""
                                              />
                                            </div>
                                          );
                                        }
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section className="propertydetail">
                        <div className="container">
                          <div className="row">
                            <div className="col-lg-12 mx-auto ms-auto">
                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="propertydetailcard">
                                    <div className="row">
                                      <div className="col-lg-3">
                                        <div className="row">
                                          <div className="col-lg-12">
                                            <div className="propertydetailpoint">
                                              {bsPlotContList?.property_type}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-12">
                                        <div className="propertydetailpoint">
                                          <div className="row">
                                            <div className="col-lg-8 col-6">
                                              Room Size :
                                            </div>
                                            <div className="col-lg-4 col-6">
                                              {
                                                bsPlotContList
                                                  ?.property_information
                                                  ?.room_size
                                              }
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-5 col-12">
                                        <div className="propertydetailpoint">
                                          <div className="row">
                                            <div className="col-lg-5 col-6">
                                              Sq Ft :
                                            </div>
                                            <div className="col-lg-7 col-6">
                                              {
                                                bsPlotContList
                                                  ?.property_information?.sq_ft
                                              }
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <h6 className="propertydes">Description</h6>
                                    <p
                                      className="smallpara"
                                      dangerouslySetInnerHTML={
                                        {
                                          __html: decode(
                                            bsPlotContList?.property_desc
                                          ),
                                        }
                                          ? {
                                              __html: decode(
                                                bsPlotContList?.property_desc
                                              ),
                                            }
                                          : "N/A"
                                      }
                                    ></p>

                                    <div className="blogcardbottom"></div>
                                    <h6 className="propertydes">
                                      Property Details
                                    </h6>
                                    {bsPlotContList?.property_type === "Plot" ? (
                                      <>
                                        <div className="row">
                                          <div className="col-lg-4">
                                            <p className="propertydescardpara">
                                              Room Size :
                                              <span className="propertydescardparabold">
                                                {bsPlotContList
                                                  ?.property_information
                                                  ?.room_size
                                                  ? bsPlotContList
                                                      ?.property_information
                                                      ?.room_size
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-lg-4">
                                            <p className="propertydescardpara">
                                              Property Type :
                                              <span className="propertydescardparabold">
                                                {bsPlotContList?.property_type
                                                  ? bsPlotContList?.property_type
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-lg-4">
                                            <p className="propertydescardpara">
                                              Facing :
                                              <span className="propertydescardparabold">
                                                {bsPlotContList
                                                  ?.property_information
                                                  ?.view_facing
                                                  ? bsPlotContList
                                                      ?.property_information
                                                      ?.view_facing
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <div className="col-lg-4">
                                            <p className="propertydescardpara">
                                              Price Per Sq.ft :
                                              <span className="propertydescardparabold">
                                                {bsPlotContList?.Price_per_sqft
                                                  ? bsPlotContList?.Price_per_sqft
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-lg-4">
                                            <p className="propertydescardpara">
                                              Road Size :
                                              <span className="propertydescardparabold">
                                                {bsPlotContList?.Road_Size
                                                  ? bsPlotContList?.Road_Size
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-lg-4"></div>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        <div className="row">
                                          <div className="col-lg-3">
                                            <p className="propertydescardpara">
                                              Property ID :
                                              <span className="propertydescardparabold">
                                                {bsPlotContList?.propertyid
                                                  ? bsPlotContList?.propertyid
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-lg-4">
                                            <p className="propertydescardpara">
                                              Year Built :
                                              <span className="propertydescardparabold">
                                                {bsPlotContList
                                                  ?.property_information
                                                  ?.year_build
                                                  ? bsPlotContList
                                                      ?.property_information
                                                      ?.year_build
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-lg-5">
                                            <p className="propertydescardpara">
                                              Price :
                                              <span className="propertydescardparabold">
                                                ₹&nbsp;
                                                {bsPlotContList
                                                  ?.property_information?.price
                                                  ? bsPlotContList
                                                      ?.property_information
                                                      ?.price
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <div className="col-lg-3">
                                            <p className="propertydescardpara">
                                              Room Size :
                                              <span className="propertydescardparabold">
                                                {bsPlotContList
                                                  ?.property_information
                                                  ?.room_size
                                                  ? bsPlotContList
                                                      ?.property_information
                                                      ?.room_size
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-lg-4">
                                            <p className="propertydescardpara">
                                              Property Type :
                                              <span className="propertydescardparabold">
                                                {bsPlotContList?.property_type
                                                  ? bsPlotContList?.property_type
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-lg-5">
                                            <p className="propertydescardpara">
                                              Property Size :
                                              <span className="propertydescardparabold">
                                                {bsPlotContList
                                                  ?.property_information?.sq_ft
                                                  ? bsPlotContList
                                                      ?.property_information
                                                      ?.sq_ft
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <div className="col-lg-3">
                                            <p className="propertydescardpara">
                                              Parking :
                                              <span className="propertydescardparabold">
                                                {bsPlotContList?.parking
                                                  ? bsPlotContList?.parking
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-lg-4">
                                            <p className="propertydescardpara">
                                              Furnished :
                                              <span className="propertydescardparabold">
                                                {bsPlotContList?.furnished_type
                                                  ? bsPlotContList?.furnished_type
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-lg-5">
                                            <p className="propertydescardpara">
                                              Facing :
                                              <span className="propertydescardparabold">
                                                {bsPlotContList
                                                  ?.property_information
                                                  ?.view_facing
                                                  ? bsPlotContList
                                                      ?.property_information
                                                      ?.view_facing
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                                <div className="propertydetailcard my-4">
                                  <h6 className="propertydes">Floor Plans</h6>
                                  <div
                                    className="accordion"
                                    id="accordionPanelsStayOpenExample"
                                  >
                                    {bsPlotContList &&
                                      bsPlotContList?.floor_information?.map(
                                        (floor, index) => {
                                          return (
                                            <div
                                              className="accordion-item"
                                              key={index}
                                            >
                                              <h2
                                                className="accordion-header"
                                                id="panelsStayOpen-headingOne"
                                              >
                                                <button
                                                  className="accordion-button"
                                                  type="button"
                                                  data-bs-toggle="collapse"
                                                  data-bs-target={`#panelsStayOpen-collapseOne${index}`}
                                                  aria-expanded="true"
                                                  aria-controls="panelsStayOpen-collapseOne"
                                                >
                                                  Floor No : {floor.floor_no}
                                                </button>
                                              </h2>
                                              <div
                                                id={`panelsStayOpen-collapseOne${index}`}
                                                className="accordion-collapse collapse show"
                                                aria-labelledby="panelsStayOpen-headingOne"
                                              >
                                                <div className="accordion-body">
                                                  <img
                                                    className="floorimage"
                                                    style={{width:"auto",
                                                    height:"400px"}}
                                                    src={
                                                      floor?.floor_image
                                                        ? floor?.floor_image
                                                        : "N/A"
                                                    }
                                                    alt=""
                                                  />
                                                  <p className="accpara">
                                                    {floor.floor_desc}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        }
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div className="client-left-section py-5">
        <div className="container my-4">
          <h1 className="banner-heading after-line mb-5">FEEL FREE TO ASK</h1>
          <div className="row">
            <div className="col-lg-6" data-aos="fade-left">
              <div>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.823571029211!2d80.23700327559305!3d13.046899587275508!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267c25ec3b519%3A0xb10841584ccc73c4!2sDALMAF%20Private%20Limited!5e0!3m2!1sen!2sin!4v1688118977225!5m2!1sen!2sin"
                  width="100%"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
            <div className="col-lg-6 col-md-12" data-aos="fade-left">
             
              <div className="row">
                <div className="col-lg-6 col-md-6">
                  <div className="mb-4">
                    <label className="form-label">
                      Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Your Name"
                      aria-invalid={Boolean(
                        bsPlotContValidation?.name?.status === false
                      )}
                      value={bsPlotSpecif?.name || ""}
                      onChange={(e) => {
                        setBsPlotContValue("name", e.target.value);
                      }}
                      onBlur={(e) => {
                        setBsPlotContValidationValue(
                          "name",
                          StringValidation(e.target.value)
                        );
                      }}
                    />
                    <small className="text-danger">
                      {bsPlotContValidation?.name?.message
                        ? `Name ${bsPlotContValidation?.name?.message}`
                        : ""}
                    </small>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="mb-4">
                    <label className="form-label">
                      Mobile No <span className="text-danger">*</span>
                    </label>
                    <input
                      type="tel"
                      maxLength={10}
                      className="form-control"
                      placeholder="Enter Your Mobile No"
                      aria-invalid={Boolean(
                        bsPlotContValidation?.mobileNumber?.status === false
                      )}
                      value={bsPlotSpecif?.mobileNumber || ""}
                      onChange={(e) => {
                        setBsPlotContValue("mobileNumber", e.target.value);
                      }}
                      onBlur={(e) => {
                        setBsPlotContValidationValue(
                          "mobileNumber",
                          PhoneNumberValidation(e.target.value)
                        );
                      }}
                    />
                    <small className="text-danger">
                      {bsPlotContValidation?.mobileNumber?.message
                        ? `Mobile no ${bsPlotContValidation?.mobileNumber?.message}`
                        : ""}
                    </small>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="mb-4">
                    <label className="form-label">
                      E- Mail ID <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter Your E- Mail ID"
                      aria-invalid={Boolean(
                        bsPlotContValidation?.emailId?.status === false
                      )}
                      value={bsPlotSpecif?.emailId?.toLowerCase() || ""}
                      onChange={(e) => {
                        setBsPlotContValue("emailId", e.target.value);
                      }}
                      onBlur={(e) => {
                        setBsPlotContValidationValue(
                          "emailId",
                          EmailValidation(e.target.value)
                        );
                      }}
                    />
                    <small className="text-danger">
                      {bsPlotContValidation?.emailId?.message
                        ? `Email ${bsPlotContValidation?.emailId?.message}`
                        : ""}
                    </small>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="mb-4">
                    <label className="form-label">
                      Service Type <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control form-control-lg"
                      value={bsPlotSpecif?.servicesType || ""}
                      onChange={(e) => {
                        setBsPlotContValue("servicesType", e.target.value);
                      }}
                      onBlur={(e) => {
                        setBsPlotContValidationValue(
                          "servicesType",
                          NonEmptyValidation(e.target.value)
                        );
                      }}
                    >
                      <option value="">---Select Service Type---</option>
                      <option value="Legal">Legal</option>
                      <option value="Audit">Audit</option>
                      <option value="Manpower">Manpower</option>
                      <option value="Auction">Auction</option>
                      <option value="Buy/Sell">Buy/Sell</option>
                    </select>
                  
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="mb-4">
                    <label className="form-label">
                      Questions <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Your Questions "
                      aria-invalid={Boolean(
                        bsPlotContValidation?.question?.status === false
                      )}
                      value={bsPlotSpecif?.question || ""}
                      onChange={(e) => {
                        setBsPlotContValue("question", e.target.value);
                      }}
                      onBlur={(e) => {
                        setBsPlotContValidationValue(
                          "question",
                          NonEmptyValidation(e.target.value)
                        );
                      }}
                    />
                    <small className="text-danger">
                      {bsPlotContValidation?.question?.message
                        ? `Question ${bsPlotContValidation?.question?.message}`
                        : ""}
                    </small>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="mb-4">
                    <label className="form-label">
                      Subject <span className="text-danger">*</span>
                    </label>
                    <textarea
                      rows="6"
                      className="form-control"
                      placeholder="Enter Subject"
                      aria-invalid={Boolean(
                        bsPlotContValidation?.subject?.status === false
                      )}
                      value={bsPlotSpecif?.subject || ""}
                      onChange={(e) => {
                        setBsPlotContValue("subject", e.target.value);
                      }}
                      onBlur={(e) => {
                        setBsPlotContValidationValue(
                          "subject",
                          NonEmptyValidation(e.target.value)
                        );
                      }}
                    ></textarea>
                    <small className="text-danger">
                      {bsPlotContValidation?.subject?.message
                        ? `Subject ${bsPlotContValidation?.subject?.message}`
                        : ""}
                    </small>
                  </div>
                </div>
                <div className="col-lg-12">
                  

                  <button
                    type="button"
                    className="btn login-btn w-100"
                    onClick={(e) => {
                      handleSubmit(e);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
              {/* )} */}
            </div>
          </div>
        </div>
      </div>
      <div className="number-counter py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6" data-aos="fade-in">
              <div className="counter-content text-start">
                <div className="d-flex align-items-center">
                  <div className="me-3">
                    <h1 className="mb-0">
                      <span className="material-symbols-rounded align-middle about-call filled-icon">
                        call
                      </span>
                    </h1>
                  </div>
                  <div className="">
                    <h5 className="fs-6 mb-0">Toll Free</h5>
                    <h5 className="mb-0 fs-4">1800-309-8445</h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="fade-in">
              <div className="counter-content text-start">
                <div className="d-flex align-items-center">
                  <div className="me-3">
                    <h1 className="mb-0">
                      <span className="material-symbols-rounded align-middle about-call filled-icon">
                        mail
                      </span>
                    </h1>
                  </div>
                  <div className="">
                    <h5 className="fs-6 mb-0">Email ID</h5>
                    <h5 className="mb-0 fs-4">info@dalmaf.com</h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="fade-in">
              <div className="counter-content text-start">
                <div className="d-flex align-items-center">
                  <div className="me-3">
                    <h1 className="mb-0">
                      <i className="fa-brands fa-whatsapp about-whatsapp-icon"></i>
                    </h1>
                  </div>
                  <div className="">
                    <h5 className="fs-6 mb-0">WhatsApp Us</h5>
                    <h5 className="mb-0 fs-4">+91 96000 38059</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <ServicesAllpages />
      </div>
      <CustomModal
        open={form}
        onClickOutside={() => {
          setForm(false);
        }}
      >
        <div className="modal-content w-50 m-auto">
          <div className="modal-body p-0 ">
            <div className="container ">
              <span
                className="material-symbols-rounded filled-icon close-icon"
                style={{
                  marginRight: "30px",
                  marginTop: "50px",
                  textShadow: "rgb(171 167 167 / 44%) 0px 3px 6px",
                }}
                onClick={() => {
                  setForm(false);
                }}
              >
                close
              </span>
              <div className="row d-flex align-items-center justify-content-center  mt-0">
                <div className="container ">
                  <div className="row justify-content-center">
                    <div className="col-lg-12">
                      <div className=" my-5 px-3">
                        <div className="row justify-content-center mt-2">
                          <div className="mb-2">
                            <b>
                              Please enter your information below, <br />
                              Our staff will contact you as soon as possible.
                            </b>
                          </div>
                          <hr />
                          <div className="col-lg-6 col-md-6">
                            <div className="mb-4">
                              <label className="form-label">
                                Name <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Your Name"
                                aria-invalid={Boolean(
                                  bsPlotContValidation1?.name?.status === false
                                )}
                                defaultValue={bsPlotCont1?.name}
                                onChange={(e) => {
                                  setServiceReqValue1("name", e.target.value);
                                }}
                                onBlur={(e) => {
                                  setServiceReqValidationValue1(
                                    "name",
                                    StringValidation(e.target.value)
                                  );
                                }}
                              />
                              <small className="text-danger">
                                {bsPlotContValidation1?.name?.message
                                  ? `Name ${bsPlotContValidation1?.name?.message}`
                                  : ""}
                              </small>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6">
                            <div className="mb-4">
                              <label className="form-label">
                                Mobile No <span className="text-danger">*</span>
                              </label>
                              <input
                                type="tel"
                                maxLength={10}
                                className="form-control"
                                defaultValue={bsPlotCont1?.mobileNumber}
                                placeholder="Enter Your Mobile No"
                                aria-invalid={Boolean(
                                  bsPlotContValidation1?.mobileNumber
                                    ?.status === false
                                )}
                                onChange={(e) => {
                                  setServiceReqValue1(
                                    "mobileNumber",
                                    e.target.value
                                  );
                                }}
                                onBlur={(e) => {
                                  setServiceReqValidationValue1(
                                    "mobileNumber",
                                    PhoneNumberValidation(e.target.value)
                                  );
                                }}
                              />
                              <small className="text-danger">
                                {bsPlotContValidation1?.mobileNumber?.message
                                  ? `Mobile no ${bsPlotContValidation1?.mobileNumber?.message}`
                                  : ""}
                              </small>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6">
                            <div className="mb-4">
                              <label className="form-label">
                                E- Mail ID{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                placeholder="Enter Your E- Mail ID"
                                aria-invalid={Boolean(
                                  bsPlotContValidation1?.email?.status === false
                                )}
                                defaultValue={
                                  bsPlotCont1?.email?.toLowerCase() || ""
                                }
                                onChange={(e) => {
                                  setServiceReqValue1(
                                    "email",
                                    e.target.value?.toLowerCase()
                                  );
                                }}
                                onBlur={(e) => {
                                  setServiceReqValidationValue1(
                                    "emailId",
                                    EmailValidation(
                                      e.target.value
                                    )?.toLowerCase()
                                  );
                                }}
                              />
                              <small className="text-danger">
                                {bsPlotContValidation1?.email?.message
                                  ? `Email ${bsPlotContValidation1?.email?.message}`
                                  : ""}
                              </small>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6">
                            <div className="mb-4">
                              <label className="form-label">Questions</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Your Questions "
                                aria-invalid={Boolean(
                                  bsPlotContValidation1?.question?.status ===
                                    false
                                )}
                                onChange={(e) => {
                                  setServiceReqValue1(
                                    "question",
                                    e.target.value
                                  );
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-lg-12">
                            <div className="mb-4">
                              <label className="form-label">
                                Service Type{" "}
                              
                              </label>
                              <select
                                className="form-control form-control-lg"
                                value={bsPlotCont1?.servicesType || ""}
                                onChange={(e) => {
                                  setServiceReqValue1(
                                    "servicesType",
                                    e.target.value
                                  );
                                }}
                                onBlur={(e) => {
                                  setServiceReqValidationValue1(
                                    "servicesType",
                                    NonEmptyValidation(e.target.value)
                                  );
                                }}
                              >
                                <option value="">
                                  ---Select Service Type---
                                </option>
                                <option value="Legal">Legal</option>
                                <option value="Audit">Audit</option>
                                <option value="Manpower">Manpower</option>
                                <option value="Auction">Auction</option>
                                <option value="Buy/Sell">Buy/Sell</option>
                              </select>
                              
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="mb-4">
                              <label className="form-label">Subject</label>
                              <textarea
                                rows="6"
                                className="form-control"
                                placeholder="Enter Subject"
                                aria-invalid={Boolean(
                                  bsPlotContValidation1?.subject?.status ===
                                    false
                                )}
                                value={bsPlotSpecif?.subject || ""}
                                onChange={(e) => {
                                  setServiceReqValue1(
                                    "subject",
                                    e.target.value
                                  );
                                }}
                              ></textarea>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <button
                              type="button"
                              className="btn login-btn w-100"
                              onClick={(e) => {
                                handleSubmitServiceform(e);
                              }}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CustomModal>
    </div>
  );
}
